import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Section } from "@/components/layout/Section";
import { StratoButton } from "@/components/common/StratoButton";
import { Reveal } from "@/components/common/Reveal";

/**
 * CtaBand — shared closing call-to-action used across pages.
 */
export const CtaBand = ({
  micro = "INIZIA ORA",
  title = "Pronto a trasformare il tuo progetto in un pezzo reale?",
  description = "Avvia il preventivo e ricevi una valutazione tecnica del tuo progetto.",
  primaryTo = "/preventivo",
  primaryLabel = "Avvia il preventivo",
  secondaryTo = "/contatti",
  secondaryLabel = "Contattaci",
}) => {
  return (
    <Section id="cta-band" tone="light" className="py-20 lg:py-28">
      <Reveal>
        <div className="mx-auto max-w-3xl text-center">
          <p className="strato-micro text-strato-blue">{micro}</p>
          <h2 className="mt-5 font-display text-3xl font-medium leading-[1.1] tracking-[-0.02em] text-strato-graphite sm:text-4xl lg:text-[3rem]">
            {title}
          </h2>
          <p className="mx-auto mt-5 max-w-[48ch] text-lg leading-[1.6] text-muted-foreground">
            {description}
          </p>
          <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <StratoButton
              as={Link}
              to={primaryTo}
              data-testid="cta-band-primary"
              className="px-7 py-4 text-[15px]"
            >
              {primaryLabel}
              <ArrowRight className="h-4 w-4" />
            </StratoButton>
            <StratoButton
              as={Link}
              to={secondaryTo}
              variant="secondary"
              data-testid="cta-band-secondary"
              className="px-7 py-4 text-[15px]"
            >
              {secondaryLabel}
            </StratoButton>
          </div>
        </div>
      </Reveal>
    </Section>
  );
};
